<template>
    <CoalDialogVue></CoalDialogVue>
    <div v-if="$store.state.wallet_manager" class="wallet">
        <div>{{ $store.state.wallet_manager.network_id == "mainnet01" ? "Mainnet" : "Testnet" }}</div>
        <div v-if="($store.state.wallet_manager.connection_state == ENUMS.WALLET.CONNECED)">
            Chain {{ $store.state.wallet_manager.chain_id == undefined ? "" : $store.state.wallet_manager.chain_id }}
        </div>
        <div title="blockheight" :style="{ 'color': $store.state.current_height_color }"
            v-show="$store.state.current_height != -1">
            bh:{{
                    $store.state.current_height
            }}
        </div>
        <div v-if="$store.state.wallet_manager.connection_state == ENUMS.WALLET.CONNECED">
            {{ shorten_account($store.state.wallet_manager.account_name)
            }}</div>
        <div style="display: block;" @click="toggle_show_bal()"
            v-if="$store.state.wallet_manager.balance != undefined && ($store.state.wallet_manager.connection_state == ENUMS.WALLET.CONNECED)">
            <span class="eyeclass"> 👁 </span><span style="position: relative;left:-12px"
                v-show="$store.state.show_bal">/</span>
            <span v-show="$store.state.show_bal">
                {{ $store.state.wallet_manager.balance }}
            </span>
            <span v-show="!$store.state.show_bal">
                ***
            </span>
            <span style="font-size: 6pt;text-align: center;">
                $KDA
            </span>
        </div>

        <button v-if="($store.state.wallet_manager.connection_state == ENUMS.WALLET.DISCONNECTED)"
            @click="connect_wallet()">connect</button>
        <button v-if="($store.state.wallet_manager.connection_state == ENUMS.WALLET.CONNECED)"
            @click="disconnect_wallet()">disconnect</button>


    </div>
    <div v-if="$store.state.wallet_manager == undefined" class="wallet">
        <button @click="download_wallet()" style="color: yellow;">no
            wallet
            found (click to download)</button>
    </div>
</template>

<script>

import ENUMS from './Enums.js'
import { vget, shorten_account, XWallet, NFTManager, MineManager, NFRManager, get_wallet_manager, QueryManager } from '@/utility'
import Pact from 'pact-lang-api'
import CoalDialogVue from './views/CoalDialog.vue'

export default {
    name: "WalletComp",
    data() {
        return { ENUMS: ENUMS, not_inited: true };
    },
    mounted() {
        var qthis = this;

        if (this.not_inited) {
            qthis.not_inited = false;
            qthis.$store.state.nft_manager = new NFTManager(qthis);
            qthis.$store.state.nfr_manager = new NFRManager(qthis);
            qthis.$store.state.mine_manager = new MineManager(qthis);
            qthis.$store.state.query_manager = new QueryManager(qthis);
            var inter = setInterval(() => {
                if ("kadena" in window) {
                    if (qthis.$store.state.wallet_manager == undefined) {
                        qthis.$store.state.wallet_manager = new XWallet(qthis);
                    }
                    if (vget(qthis.$store.state.wallet_manager, "account_name") != undefined) {
                        get_wallet_manager(qthis).then(wal => wal.get_balance());
                        if (qthis.$store.state.balance_update_minterval != undefined) {
                            clearInterval(qthis.$store.state.balance_update_minterval);
                        }
                        qthis.$store.state.balance_update_minterval = setInterval(() => {
                            get_wallet_manager(qthis).then(wal => wal.get_balance());
                        }, 30000);
                        get_wallet_manager(qthis).then(wal => {
                            console.log(wal)
                            Pact.event.recent("1", 10, 10, "mainnet01", "https://api.chainweb.com")//.then(x => console.log(x));
                            // Pact.event.stream(0, ["13"], function(x){
                            //     console.log("MMMMM",x)
                            //     qthis.$store.commit("addToast",[x.name,x.params])
                            // }, "mainnet01", "https://api.chainweb.com");
                            var netid = vget(wal, "network_id");
                            var eurl = "https://api.chainweb.com/chainweb/0.0/mainnet01/header/updates";
                            if (netid == "testnet04") {
                                eurl = "https://api.testnet.chainweb.com/chainweb/0.0/testnet04/header/updates";
                            }
                            var evtSource = new EventSource(eurl);
                            evtSource.addEventListener("BlockHeader", (x) => {
                                var dat = JSON.parse(x.data);
                                get_wallet_manager(qthis).then(wal => {
                                    if ((dat.header.chainId + "") == vget(wal, "chain_id")) {
                                        qthis.$store.state.current_height = dat.header.height;
                                        qthis.$store.state.current_height_time = new Date().getTime() / 1000;
                                    }
                                });
                            });
                            // Pact.event.height("1", 2815397, "testnet04", "https://api.testnet.chainweb.com").then(x => {
                            // })
                            setInterval(() => {
                                if (qthis.$store.state.current_height != -1) {
                                    if (new Date().getTime() / 1000 - qthis.$store.state.current_height_time < 12) {
                                        qthis.$store.state.current_height_color = "greenyellow";
                                    }
                                    else if (new Date().getTime() / 1000 - qthis.$store.state.current_height_time < 24) {
                                        qthis.$store.state.current_height_color = "yellow";
                                    }
                                    else if (new Date().getTime() / 1000 - qthis.$store.state.current_height_time < 36) {
                                        qthis.$store.state.current_height_color = "red";
                                    }
                                }
                            }, 2000);
                            // evtSource.onopen = function () {
                            // };
                        });
                        clearInterval(inter);
                    }
                }
            }, 100);
            var tehnav = new URL(window.location.href);
            try {
                var tehcmd = tehnav.searchParams.get("cmd").toLowerCase();
                if (tehcmd == "listnfts") {
                    qthis.$store.state.list_nfts_seeker = tehnav.searchParams.get("seeker");
                    qthis.$store.commit("changeView", ENUMS.VIEWS.LISTNFTS)

                }
                else if (tehcmd == "coalsonsale") {
                    qthis.$store.commit("changeView", ENUMS.VIEWS.LISTONSALE)

                }
            }
            catch (error) {
                // 
            }
        }
    },
    computed: {},
    methods: {
        connect_wallet() {
            get_wallet_manager(this).then(wlt => wlt.connect());
        },
        disconnect_wallet() {
            get_wallet_manager(this).then(wlt => wlt.disconnect());
        },
        download_wallet() {
            window.open("https://xwallet.kaddex.com/");
        },
        toggle_show_bal() {
            var qthis = this;
            qthis.$store.state.show_bal = !qthis.$store.state.show_bal;
            localStorage.show_bal = qthis.$store.state.show_bal;
        },
        shorten_account,
        vget
    },
    components: { CoalDialogVue }
}
</script>

<style scoped>
.wallet {
    z-index: 100;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;
    border-left: solid;
    padding-left: 3%;
}

.eyeclass {
    color: rgba(158, 158, 158, 0.8);
}
</style>